@import './commonstyle.module.scss';

.inputWrapper {
  margin-top: 1.5em;
  display: flex;
  flex-direction: column;

  &.desktopPageWrapper {
    width: 60%;
  }

  .confirmBtn {
    margin: 1em 0;
  }
}
